import { dia } from '@joint/core'
import type { ExportData } from '../../../../map-editor-entities/schema/exportSchema'
import { buildMapData } from './buildMapData'

export { routeObjectByType } from './buildMapData'
export { convertElementToMapObject, parseSVGPathToAbsoluteCoords } from './elementConverter'
export { extractPosition, extractPoints, calculateCentroid } from './geometryUtils'
export { isRelationshipProperty, extractRelations, processRelationshipValue, extractAllRelationProperties } from './relationshipExtractor'
export { validateMapData } from './validateMapData'
export { transformToCCTV, transformToWarningCCTV, transformToZone, transformToColumn, transformToParkingLocation, transformToSensor, transformToCharger, transformToGuideBoard, transformToElevator, transformToEmergencyBell, transformToArrow, transformToLine, transformToEntrance, transformToOnePassReader, transformToOccupancyLight, transformToLight, transformToCustomObject } from './transformers'

export interface FloorData {
  name: string
  order: number
  graph: dia.Graph
}

/**
 * Convert JointJS graphs from all floors to ExportData JSON format
 */
export function exportGraphToJSON(
  floors: FloorData[],
  metadata: {
    lotName: string
    lotCreated: string
    floorOrder?: number
    author?: string
    description?: string
  },
  layerFilter?: Set<string>
): ExportData {
  // Build parkingLotLevels from all floors
  const parkingLotLevels = floors
    .sort((a, b) => a.order - b.order) // Sort by floor order
    .map(floor => ({
      name: floor.name,
      mapData: buildMapData(floor.graph, {
        lotName: metadata.lotName,
        floorName: floor.name,
        floorOrder: metadata?.floorOrder ?? floor.order,
        author: metadata.author,
        description: metadata.description
      }, layerFilter)
    }))

  return {
    data: {
      createdAt: metadata.lotCreated,
      name: metadata.lotName,
      parkingLotLevels
    }
  }
}

/**
 * Download JSON as a file
 */
export function downloadJSON(data: any, filename: string = 'map-export.json') {
  const jsonString = JSON.stringify(data, null, 2)
  const blob = new Blob([jsonString], { type: 'application/json' })
  const url = URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}
